import React, { useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { FaCalendarAlt, FaArrowLeft, FaBuilding, FaShieldAlt, FaMicrochip, FaLeaf, FaBrain, FaShareAlt, FaClock, FaFacebookF, FaTwitter, FaLinkedinIn, FaTimes } from 'react-icons/fa';

const newsItems = {
  'sovereign-ai--societal-impact-and-sweden-s-competitiveness': {
    id: 'sovereign-ai-society',
    title: 'Sovereign AI, Societal impact and Sweden\'s competitiveness',
    date: 'January 10, 2026',
    author: '6G AI Sweden AB',
    category: 'Event',
    excerpt: 'Join us for a landmark event exploring secure AI and sustainable innovation in Sweden. The society as a whole needs to collaborate in the areas of data-driven insights and decisions.',
    content: `The path towards secure AI and sustainable innovation

Time: 10:00–12:30  
Date: 16 January 2026  
Location: Grant Thornton, Kungsgatan 57, Stockholm

Our society faces a number of complex challenges; polarization, social exclusion, geopolitical conflicts, mental health and climate change. The society as a whole needs to collaborate in the areas of data-driven insights and decisions, defining the way forward for Sweden and its citizens.

Maintaining competitiveness requires more than technology - we must make our societal value visible and develop Swedish sovereign AI with full data control, in secure Swedish or European data centers, governed by our ethical principles.

This is as important as energy supply - a prerequisite for research, innovation and a sustainable, competitive society.

Program and speakers:

**How & why has Swedish Hockey League measured its impact, how can the method drive change in society?**
- Helena Mueller, Director Sustainability Consulting Grant Thornton
- Johan Cahling, Head of Sustainable Development Swedish Hockey League

**Sweden at a crossroads: Competitiveness with the help of superior AI**
- Thomas Ekman, 6G AI Board Member, former CEO of the Axel Johnson Group, CEO Dustin, CEO Tele2 Sweden and Leading Roles within MTG

**Protecting lives, promoting research and strengthening trust with Swedish AI. How responsible AI can accelerate medical breakthroughs and strengthen trust in data-driven research.**
- Elisabet Dahlin, Chairwoman of the Swedish Childhood Cancer Foundation

**Sovereign AI and global power dynamics – what Sweden must prepare for. A strategic overview of how AI concentration and geopolitics affect competitiveness and why Sweden must secure access to sovereign computing power and data environments.**
- MA Zaman, Chairman & Group CEO 6G AI SWEDEN AB, formerly Senior Executive Vice President Millicom Int. Cellular & Vice President of Kinnevik`,
    features: [
      { icon: FaCalendarAlt, text: 'January 16, 2026' },
      { icon: FaBuilding, text: 'Grant Thornton, Stockholm' },
      { icon: FaClock, text: '10:00 - 12:30' },
    ]
  },
  '6g-ai-sweden-ab-launches-sovereign-ai-infrastructure-in-sweden': {
    id: 'launch-sovereign-ai',
    title: '6G AI Sweden AB launches Sovereign AI Infrastructure in Sweden',
    date: 'January 9, 2026',
    author: '6G AI Sweden AB',
    category: 'Press Release',
    excerpt: '6G AI Sweden AB announces commercial launch of sovereign AI infrastructure in Sweden, positioning Sweden at the forefront of artificial intelligence with complete data confinement within national borders.',
    content: `**STOCKHOLM, Sweden, 2nd July, 2025** - 6G AI Sweden AB today announced the commercial launch of new sovereign AI Infrastructure in Sweden, a transformative technology project that positions Sweden at the forefront of artificial intelligence with the ability to provide complete data confinement within national borders.

The AI Cloud facility is strategically located in atNorth's SWE01 datacenter in Stockholm's Kista technology district. It is **fully aligned with the NVIDIA reference architecture** for optimal performance and delivers direct access to NVIDIA H200 GPUs. 6G AI Sweden AB has previously signed an agreement to purchase Nvidia GPUs at a total value of SEK 2.1 billion.

6G AI Sweden is leveraging **Nvidia AI Enterprise suite, Nvidia AI Blueprints, Use Cases and pre-trained models** and is providing Swedish organizations with computational capabilities previously accessible only through foreign-controlled infrastructure, which represents an important goal for European technological independence.

*"Sweden has consistently led global technological transformation, from telecommunications to digital innovation,"* stated M.A. Zaman, Founder and Chairman of 6G AI Sweden AB. *"Our AI Factory extends this legacy, providing Swedish companies with world-class AI capabilities whilst maintaining absolute data sovereignty - a critical consideration for enterprises navigating an increasingly complex geopolitical landscape."*

The initiative has attracted distinguished industry leaders to its board. Johnny Svedberg, a telecommunications veteran with over three decades of experience at Tele2, Arelion (Previously Telia Carrier) and Indosat Ooredoo, brings invaluable expertise in building critical national infrastructure. "Having spent my career architecting telecommunications networks that became the backbone of Sweden's digital economy, I see the AI Cloud facility as the next critical step in national infrastructure," commented Svedberg. "This sovereign AI capability will prove as transformative for Swedish competitiveness as the mobile network technology has been for Sweden globally."

**Comprehensive AI Service Portfolio**

6G AI Sweden's comprehensive service portfolio encompasses three distinct offerings designed to accelerate AI adoption across Swedish industry.

**Infrastructure tier:**
Bare metal access to H200 SXM GPUs, with VMs, secure storage and connectivity.

**Development tier:**
6G AI Use Case Dev Kit helping Product and Process Development teams implement enterprise applications faster through APIs, SDKs and access to NVIDIA AI Enterprise (NVAIE) suite, including Blueprints and pre-trained models.

**Solutions tier:**
Turnkey AI applications for immediate business deployment, including code free, automated implementation of Agentic AI across domains.

*"The convergence of AI and traditional industry represents Sweden's greatest opportunity in decades." noted Thomas Ekman, newly appointed board member with extensive experience from the Nordic Industry and technology transformation. "Our sovereign AI infrastructure ensures that Swedish enterprises can embrace this transformation without compromising data integrity or regulatory compliance; considerations that have become paramount not only for financial institutions and regulated industries, but for all companies and institutions regardless of industry."*

**EU Regulatory compliance and Sustainability focus**

The 6G AI Sweden facility operates under **full compliance with GDPR** requirements, with all data processing occurring within Swedish jurisdiction. **Compliance with EU AI Act** ensures that AI systems are safe, transparent, ethical, and respect human rights.

The operation addresses growing concerns amongst European enterprises regarding data sovereignty and regulatory compliance in an era of increasing digital protectionism.

Environmental sustainability is a crucial part of 6G AI Sweden's strategy. The Kista facility operates exclusively on renewable energy sources and leverages atNorth's heat recovery system, **returning surplus heat directly into Stockholm's district heating network**.

Anders Fryxell, Chief Sales Officer at atNorth, added: *"Our partnership with 6G AI Sweden demonstrates that nations need not compromise between technological advancement and sustainability commitments. The infrastructure we've deployed represents the future of responsible AI development."*

**About 6G AI Sweden AB**

6G AI Sweden AB pioneers sovereign AI infrastructure solutions, enabling Swedish enterprises to develop artificial intelligence capabilities whilst maintaining complete data sovereignty and regulatory compliance.

The initiative forms part of 6G AI Sweden AB's broader strategy to establish Sweden as a global centre of excellence for AI development and deployment, with expansion plans already underway to scale capacity in response to anticipated demand.

Johan Dennelind, former International Telecom CEO and now Strategic Advisor to 6G AI Sweden AB says: *"It's about time that companies looking to use the best of AI, also can buy this service locally from a trusted partner. 6G AI offers a unique set of services that we know are in high demand in Sweden and other countries, partly because it's state of the art technology and AI services from Nvidia, but also because it is local, safe and secure. This is secure digital sovereignty, here and now."*

**Contact 6G AI Sweden AB:**
Conny Karlsson
Chief Operating Officer
Email: info@6gai.se
Phone: +46 70 710 7908`,
    features: [
      { icon: FaShieldAlt, text: 'GDPR & EU AI Act Compliant' },
      { icon: FaMicrochip, text: 'NVIDIA H200 GPUs' },
      { icon: FaLeaf, text: '100% Renewable Energy' },
      { icon: FaBrain, text: 'NVIDIA AI Enterprise' },
    ]
  },
  'rui-gomes-appointed-chief-technology-officer': {
    id: 'rui-gomes-cto',
    title: '6G AI Sweden AB Appoints Rui Gomes as Chief Technology Officer',
    date: 'March 10, 2026',
    author: '6G AI Sweden AB',
    category: 'Press Release',
    excerpt: 'New leadership bolsters the company\'s mission to deliver trusted, sovereign high-performance cloud infrastructure for AI innovation across Europe.',
    image: '/RuiGomes_Headshot.jpg',
    content: `Stockholm, Sweden | 10 March 2026 – 6G AI Sweden AB (6G AI), the leading Nordic AI cloud provider, today announced the appointment of Rui Gomes as Chief Technology Officer (CTO). Gomes will lead 6G AI's platform strategy, engineering execution, and infrastructure development as the company accelerates the development of Sweden's emerging sovereign AI cloud infrastructure and prepares to scale its GPU-as-a-Service (GPUaaS) platform across Europe.

The announcement comes as global demand for AI compute continues to surge and European organizations increasingly seek infrastructure that ensures data sovereignty, regulatory compliance, and trusted AI deployment within national jurisdictions.

Gomes will lead 6G AI's platform architecture, engineering strategy and infrastructure development. His appointment will support the company's next phase of growth alongside its mission to bring cutting-edge AI technology to secure cloud environments with seamless AI accessibility, enterprise-grade reliability, and robust performance for organizations deploying advanced workloads.

6G AI's platform addresses the growing demand for large-scale AI training, inference and high-performance workloads, operating under strict data sovereignty laws to ensure AI workloads remain within European jurisdiction and fully compliant with regional regulatory frameworks.

"AI infrastructure has to be trusted before it can be transformative," said Gomes. "Our focus is to build a purpose-built, sovereign AI cloud infrastructure for enterprises, research institutions, and regulated industries – one that customers can adopt quickly, operate confidently, and scale globally while maintaining full control over their data and workloads."

By combining sovereign cloud architecture with next-generation AI hardware, 6G AI aims to enable organizations to adopt advanced AI capabilities without compromising data governance or regulatory compliance.

**Strengthening Europe's Sovereign AI Infrastructure**

Under Gomes' leadership, 6G AI will accelerate the development of a platform-first sovereign AI cloud architecture, delivering:

- Rapid deployment of AI workloads through operational excellence, transparent scalability and a customer first approach
- Alignment with Swedish jurisdiction and European compliance requirements, ensuring organizations maintain full control over data and AI workloads
- Reliable performance by design across the entire tech stack, from compute infrastructure to workload orchestration

M. A. Zaman, Founder and Group CEO of 6G AI Sweden AB, said the appointment reflects the growing importance of operational excellence in building trusted, national-scale AI infrastructure.

"Our strategy is to build and operate sovereign AI infrastructure as a critical national capability," he stated. "Strengthening our operational leadership is therefore as important as expanding compute capacity. The appointment of Rui Gomes as CTO marks an important step in scaling our HPC environments and operations in Sweden with consistent, high-quality delivery."

**About Rui Gomes**

Rui Gomes brings extensive experience in high-performance computing and digital infrastructure, having previously held senior leadership roles at atNorth, where he led HPC infrastructure operations and product development in large-scale data centre environments.

His expertise across telecom, media and technology sectors will support 6G AI's mission to deliver secure, high-performance AI infrastructure built specifically for European innovation. The appointment comes as organizations across Europe increase investment in sovereign digital infrastructure to support the next wave of AI-driven innovation.

**About 6G AI**

6G AI Sweden AB is a Swedish AI cloud provider offering sovereign GPU compute designed for easy AI adoption and predictable pricing. The company provides high-performance AI infrastructure powered by NVIDIA GPU technology. Operating from atNorth's SWE01 data center in Kista, Stockholm, the platform capitalizes on sustainability capabilities to help reduce the environmental footprint of large-scale AI workloads.

Hosted in Sweden, 6G AI's next-generation cloud infrastructure is designed to accelerate enterprise AI adoption while ensuring compliance with European data sovereignty requirements for industries including research, healthcare, telecommunications, and public sector innovation.`,
    features: [
      { icon: FaMicrochip, text: 'NVIDIA GPU Technology' },
      { icon: FaShieldAlt, text: 'Data Sovereignty' },
      { icon: FaLeaf, text: 'Sustainable Infrastructure' },
    ]
  }
};

function NewsDetail() {
  const { slug } = useParams();
  const newsItem = newsItems[slug];
  const [showShareModal, setShowShareModal] = useState(false);

  const getShareUrl = () => {
    const url = `${window.location.origin}/news/${slug}`;
    return url;
  };

  const shareToFacebook = () => {
    const url = getShareUrl();
    window.open(`https://www.facebook.com/sharer/sharer.php?u=${url}&quote=${encodeURIComponent(newsItem?.title || '')}`, '_blank', 'width=600,height=400');
  };

  const shareToX = () => {
    const url = getShareUrl();
    window.open(`https://twitter.com/intent/tweet?url=${url}&text=${encodeURIComponent(newsItem?.title || '')}`, '_blank', 'width=600,height=400');
  };

  const shareToLinkedIn = () => {
    const url = getShareUrl();
    window.open(`https://www.linkedin.com/sharing/share-offsite/?url=${url}`, '_blank', 'width=600,height=400');
  };

  if (!newsItem) {
    return (
      <>
        <div className="page-header">
          <Container>
            <Link to="/news" className="back-link">
              <FaArrowLeft /> Back to News
            </Link>
            <h1 className="page-title">Article Not Found</h1>
          </Container>
        </div>
        <section className="section">
          <Container>
            <p>The requested article could not be found.</p>
          </Container>
        </section>
      </>
    );
  }

  const contentParagraphs = newsItem.content.split('\n\n').filter(p => p.trim());

  return (
    <>
      <Helmet>
        <title>{newsItem.title} | 6G AI Sweden AB</title>
        <meta name="description" content={newsItem.excerpt} />
        <meta property="og:title" content={newsItem.title} />
        <meta property="og:description" content={newsItem.excerpt} />
        <meta property="og:type" content="article" />
      </Helmet>

      <div className="page-header">
        <Container>
          <Link to="/news" className="back-link">
            <FaArrowLeft /> Back to News
          </Link>
          <Row className="align-items-end mt-4">
            <Col lg={8}>
              <div className="news-meta">
                <span className="news-category">{newsItem.category}</span>
                <span className="news-date">
                  <FaCalendarAlt /> {newsItem.date}
                </span>
              </div>
              <h1 className="page-title">{newsItem.title}</h1>
              <p className="news-author">By {newsItem.author}</p>
              {newsItem.image && (
                <img 
                  src={newsItem.image} 
                  alt={newsItem.title} 
                  style={{ width: '25%', borderRadius: '8px', marginTop: '1rem' }} 
                />
              )}
            </Col>
          </Row>
        </Container>
      </div>

      <section className="section">
        <div className="news-card-background">
          <Container>
            <Row>
              <Col lg={8}>
                <article className="news-content">
                  {contentParagraphs.map((paragraph, index) => {
                    if (paragraph.startsWith('**') && paragraph.endsWith('**')) {
                      return <h3 key={index} className="news-content-h3">{paragraph.replace(/\*\*/g, '')}</h3>;
                    }
                    if (paragraph.startsWith('- ')) {
                      const items = paragraph.split('\n').filter(p => p.startsWith('- '));
                      return (
                        <ul key={index} className="news-content-list">
                          {items.map((item, i) => (
                            <li key={i}>{item.replace(/^- /, '')}</li>
                          ))}
                        </ul>
                      );
                    }
                    return <p key={index} className="news-content-p">{paragraph}</p>;
                  })}
                </article>
              </Col>
              <Col lg={4}>
                <div className="news-sidebar">
                  <div className="news-features-card">
                    <h4 className="sidebar-title">Key Details</h4>
                    {newsItem.features.map((feature, idx) => (
                      <div key={idx} className="news-feature">
                        <feature.icon className="news-feature-icon" />
                        <span>{feature.text}</span>
                      </div>
                    ))}
                  </div>
                  
                <div className="news-share">
                  <h4 className="sidebar-title">Share</h4>
                  <Button variant="outline-light" className="share-btn" onClick={() => setShowShareModal(true)}>
                    <FaShareAlt /> Share article
                  </Button>
                </div>

                {showShareModal && (
                  <div className="share-modal-overlay" onClick={() => setShowShareModal(false)}>
                    <div className="share-modal" onClick={e => e.stopPropagation()}>
                      <div className="share-modal-header">
                        <h4>Share this article</h4>
                        <button className="share-modal-close" onClick={() => setShowShareModal(false)}>
                          <FaTimes />
                        </button>
                      </div>
                      <div className="share-modal-options">
                        <button className="share-option share-facebook" onClick={shareToFacebook}>
                          <FaFacebookF /> Facebook
                        </button>
                        <button className="share-option share-x" onClick={shareToX}>
                          <FaTwitter /> X
                        </button>
                        <button className="share-option share-linkedin" onClick={shareToLinkedIn}>
                          <FaLinkedinIn /> LinkedIn
                        </button>
                      </div>
                    </div>
                  </div>
                )}
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </section>

      <style>{`
        .news-card-background {
          background: rgba(18, 18, 20, 0.75);
          backdrop-filter: blur(20px) saturate(180%);
          -webkit-backdrop-filter: blur(20px) saturate(180%);
          border: 1px solid var(--md-sys-color-outline-variant);
          border-radius: var(--radius-extra-large);
          padding: var(--space-xl);
          box-shadow: var(--md-sys-elevation-3);
        }

        .back-link {
          display: inline-flex;
          align-items: center;
          gap: var(--space-sm);
          color: var(--md-sys-color-on-surface-variant);
          font-size: var(--font-body-md);
          transition: all var(--motion-duration-medium2) var(--motion-easing-emphasized);
        }

        .back-link:hover {
          color: var(--md-sys-color-primary);
          gap: var(--space-md);
        }

        .news-meta {
          display: flex;
          align-items: center;
          gap: var(--space-md);
          margin-bottom: var(--space-md);
          flex-wrap: wrap;
        }

        .news-category {
          background: var(--md-sys-color-primary-container);
          color: var(--md-sys-color-on-primary-container);
          padding: var(--space-xs) var(--space-md);
          border-radius: var(--radius-full);
          font-size: var(--font-label-md);
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.05em;
        }

        .news-date {
          display: flex;
          align-items: center;
          gap: var(--space-xs);
          color: var(--md-sys-color-on-surface-variant);
          font-size: var(--font-body-md);
        }

        .news-date svg {
          color: var(--md-sys-color-secondary);
        }

        .news-author {
          color: var(--md-sys-color-on-surface-variant);
          font-size: var(--font-body-md);
          margin-top: var(--space-sm);
        }

        .news-content {
          color: var(--md-sys-color-on-surface);
        }

        .news-content-p {
          font-size: var(--font-body-lg);
          line-height: 1.8;
          margin-bottom: var(--space-lg);
          color: var(--md-sys-color-on-surface);
        }

        .news-content-h3 {
          font-size: var(--font-headline-sm);
          font-weight: 700;
          margin-top: var(--space-xl);
          margin-bottom: var(--space-md);
          color: var(--md-sys-color-on-surface);
        }

        .news-content-list {
          margin-bottom: var(--space-lg);
          padding-left: var(--space-lg);
        }

        .news-content-list li {
          font-size: var(--font-body-md);
          line-height: 1.7;
          margin-bottom: var(--space-sm);
          color: var(--md-sys-color-on-surface-variant);
        }

        .news-sidebar {
          position: sticky;
          top: 120px;
        }

        .news-features-card {
          background: var(--md-sys-color-surface-container);
          border: 1px solid var(--md-sys-color-outline-variant);
          border-radius: var(--radius-extra-large);
          padding: var(--space-lg);
          margin-bottom: var(--space-lg);
        }

        .sidebar-title {
          font-size: var(--font-title-md);
          font-weight: 600;
          margin-bottom: var(--space-md);
          color: var(--md-sys-color-on-surface);
        }

        .news-feature {
          display: flex;
          align-items: center;
          gap: var(--space-sm);
          color: var(--md-sys-color-on-surface-variant);
          font-size: var(--font-body-md);
          padding: var(--space-sm) 0;
          border-bottom: 1px solid var(--md-sys-color-outline-variant);
        }

        .news-feature:last-child {
          border-bottom: none;
        }

        .news-feature-icon {
          color: var(--md-sys-color-tertiary);
          font-size: 1rem;
        }

        .news-share {
          background: var(--md-sys-color-surface-container);
          border: 1px solid var(--md-sys-color-outline-variant);
          border-radius: var(--radius-extra-large);
          padding: var(--space-lg);
        }

        .share-btn {
          width: 100%;
          justify-content: center;
        }

        .share-modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.7);
          backdrop-filter: blur(5px);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 9999;
          animation: fadeIn var(--motion-duration-short3) var(--motion-easing-standard);
        }

        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }

        .share-modal {
          background: var(--md-sys-color-surface-container);
          border: 1px solid var(--md-sys-color-outline-variant);
          border-radius: var(--radius-extra-large);
          padding: var(--space-lg);
          min-width: 300px;
          box-shadow: var(--md-sys-elevation-5);
          animation: slideUp var(--motion-duration-medium2) var(--motion-easing-emphasized-decelerate);
        }

        @keyframes slideUp {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }

        .share-modal-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: var(--space-lg);
        }

        .share-modal-header h4 {
          margin: 0;
          font-size: var(--font-title-lg);
          font-weight: 600;
          color: var(--md-sys-color-on-surface);
        }

        .share-modal-close {
          background: none;
          border: none;
          color: var(--md-sys-color-on-surface-variant);
          cursor: pointer;
          padding: var(--space-xs);
          border-radius: var(--radius-full);
          transition: all var(--motion-duration-short2) var(--motion-easing-standard);
        }

        .share-modal-close:hover {
          background: var(--md-sys-state-hover-overlay);
          color: var(--md-sys-color-on-surface);
        }

        .share-modal-options {
          display: flex;
          flex-direction: column;
          gap: var(--space-sm);
        }

        .share-option {
          display: flex;
          align-items: center;
          gap: var(--space-md);
          padding: var(--space-md) var(--space-lg);
          border: 1px solid var(--md-sys-color-outline-variant);
          border-radius: var(--radius-medium);
          background: transparent;
          color: var(--md-sys-color-on-surface);
          font-size: var(--font-body-md);
          font-weight: 500;
          cursor: pointer;
          transition: all var(--motion-duration-short3) var(--motion-easing-standard);
        }

        .share-option:hover {
          transform: translateX(4px);
        }

        .share-option.share-facebook:hover {
          background: #1877f2;
          border-color: #1877f2;
          color: white;
        }

        .share-option.share-x:hover {
          background: #000000;
          border-color: #000000;
          color: white;
        }

        .share-option.share-linkedin:hover {
          background: #0a66c2;
          border-color: #0a66c2;
          color: white;
        }

        @media (max-width: 992px) {
          .news-sidebar {
            position: static;
            margin-top: var(--space-xl);
          }
        }
      `}</style>
    </>
  );
}

export default NewsDetail;
